/*@flow*/
import { useContext } from 'react';
import commands from './commands';
import BuilderContext from './Context';

export default function useCommands(): {|
  close: (opts?: {confirm: boolean, ...}) => void,
  dupResource: (o: $Shape<{id: ID, resourceName: string, ...}>) => void,
  editResource: (o: $Shape<{id: ID, resourceName: string, ...}>) => void,
  newResource: (o: $Shape<{resource: any, resourceName: string, ...}>) => void,
  open: () => void,
  reset: () => void,
  selectResource: (name: string) => void,
  set: (path: string, value: any) => void,
  setResourceKey: (key: string, value: any) => void,
  showForm: () => void,
  startIntegration: () => void,
|} {
  const ctx = useContext(BuilderContext);
  return commands(ctx);
}
